import { AllUsersTable } from "../../components/UserTable";

export function Users() {
    return <AllUsersTable />
}